<mat-toolbar class="header">
  <span>{{ title }}</span>
  <span class="spacer"></span>
  <button [routerLink]="['/']" mat-button>Home</button>
  <button [routerLink]="['/map']" mat-button>Map</button>
  <button [routerLink]="['/login']" mat-button>Login</button>
</mat-toolbar>
